import { HttpBackend, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { DataService } from 'src/app/core/services/data.service';
import {
  SearchParameterTestResponse,
  TestandParamterSearchRequestModel,
  TestandParamterSearchResponseModel,
  TestSearchParameterRequest
} from '../models/search-test-parameter.model';
import { SelectedItemForDownloadModel } from '../component/test-parameters/selected-item.model';

@Injectable({
  providedIn: 'root'
})
export class SearchParametertestService {
  private readonly http: HttpClient;
  private readonly baseRoute: string;
  public selectedItemForDownlaod: SelectedItemForDownloadModel[] = [];

  constructor(
    @Inject('BASE_URL') public readonly baseUrl: string,
    private readonly dataService: DataService,
    handler: HttpBackend
  ) {
    this.http = new HttpClient(handler);
    this.baseRoute = `${baseUrl}api/commercial-items`;
  }

  public searchParameterTestOld(searchRequest: TestSearchParameterRequest): Observable<SearchParameterTestResponse> {
    const api = `${this.baseRoute}/search`;
    return this.dataService.put<any, any>(api, searchRequest, true).pipe(
      map((res: SearchParameterTestResponse) => {
        return res;
      }),
      catchError((err: any) => {
        return of(err?.error);
      })
    );
  }

  public searchParameterTest(searchRequest: TestandParamterSearchRequestModel): Observable<SearchParameterTestResponse> {
    const api = `${this.baseRoute}/search`;
    return this.dataService.put<any, any>(api, searchRequest, true).pipe(
      map((res: TestandParamterSearchResponseModel) => {
        return res;
      }),
      catchError((err: any) => {
        return of(err?.error);
      })
    );
  }
}
